export default __webpack_public_path__ + "static/share-image-2329dafe4afb41cd96d7ab5f50a567e0.png";